import http from "@/services/http-common-myip";

class wsMyIp {
	getMyIp() {
		return http.get(`/json`); //?token=fb4a87c9e2415b
	}
}

export default new wsMyIp();
